import { type ManualApproveHandlerSchema } from 'modules/procurement/components/procurementTypes/Workflows/sidePanels/schemas/manualApproveHandler'
import { HandlerFormComponentPayload } from 'modules/workflows/contexts/WorkflowContext'
import { DEFAULT_DURATION_UNIT, isValidDateUnit } from 'modules/workflows/lib/durationUnit'

import { mapEmployeeSegments } from './employeeSegmentMapper'

export const manualApproveNodeToSchemaMapper = (
  payload: HandlerFormComponentPayload
): ManualApproveHandlerSchema['nodeData']['payload'] => {
  const due_on_unit = String(payload.due_on_unit)
  const reviewer_ids = payload.reviewer_ids
  const employee_segments = payload.employee_segments
  const fallback_reviewer_ids = payload.fallback_reviewer_ids
  const fallback_employee_segments = payload.fallback_employee_segments
  const dueOnValue = Number(payload.due_on_value ?? 1)
  const durationUnit = isValidDateUnit(due_on_unit) ? due_on_unit : DEFAULT_DURATION_UNIT

  const mappedEmployeeSegments = mapEmployeeSegments(employee_segments)
  const mappedFallbackEmployeeSegments = mapEmployeeSegments(fallback_employee_segments)

  // Filter out 'resource_owner' as it's not supported in manual approve schema
  const filteredEmployeeSegments = mappedEmployeeSegments?.filter(
    (segment) => segment.name !== 'resource_owner'
  )
  const filteredFallbackEmployeeSegments = mappedFallbackEmployeeSegments?.filter(
    (segment) => segment.name !== 'resource_owner'
  )

  return {
    due_on_value: dueOnValue,
    due_on_unit: durationUnit,
    ...(reviewer_ids && Array.isArray(reviewer_ids) && reviewer_ids.length > 0
      ? { reviewer_ids: reviewer_ids.map((id) => Number(id)) }
      : {}),
    ...(filteredEmployeeSegments && filteredEmployeeSegments.length > 0
      ? { employee_segments: filteredEmployeeSegments }
      : {}),
    ...(fallback_reviewer_ids &&
    Array.isArray(fallback_reviewer_ids) &&
    fallback_reviewer_ids.length > 0
      ? { fallback_reviewer_ids: fallback_reviewer_ids.map((id) => Number(id)) }
      : {}),
    ...(filteredFallbackEmployeeSegments && filteredFallbackEmployeeSegments.length > 0
      ? { fallback_employee_segments: filteredFallbackEmployeeSegments }
      : {}),
  }
}
